import { render, staticRenderFns } from "./contradictions.vue?vue&type=template&id=3323b571&"
import script from "./contradictions.vue?vue&type=script&lang=js&"
export * from "./contradictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports